<!-- 体验项目列表 -->
<template>
  <div class="all">
    <div class="" v-loading="loading">
      <!-- 顶部搜索 -->
      <div class="s_wrapper">
        <el-cascader collapse-tags v-model="categoryValue" :options="optionArry" placeholder="项目分类" :props="{ expandTrigger: 'hover', label: 'categoryName', value: 'categoryId', children: 'children', emitPath: false, checkStrictly: false,multiple:true }" @change="onSearch" clearable></el-cascader>
        <el-input class="s_input" v-model="projectName" placeholder="请搜索项目名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
      </div>
      <!-- 表格 -->
      <div class="g_table" style="max-height: 540; overflow: auto">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" width="50" show-overflow-tooltip fixed="left">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" show-overflow-tooltip min-width="200"></el-table-column>
          <el-table-column prop="categoryName" label="分类" show-overflow-tooltip min-width="140"></el-table-column>
          <el-table-column prop="price" label="定价(元)" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="linePrice" label="划线价(元)" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="durationMinute" label="服务时长(min)" show-overflow-tooltip min-width="120"></el-table-column>
          <el-table-column prop="projectCount" label="次数" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="commissionRate" label="员工提成比例(%)" show-overflow-tooltip min-width="140">
            <template slot-scope="scope">
              <div>{{ scope.row.commissionRate?scope.row.commissionRate:'——' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="commissionAmount" label="员工提成金额(元)" show-overflow-tooltip min-width="140">
            <template slot-scope="scope">
              <div>{{ scope.row.commissionAmount?scope.row.commissionAmount:'——' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="storeRate" label="门店分账比例(%)" show-overflow-tooltip min-width="140"></el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="210" fixed="right">
            <template slot-scope="scope">
              <el-button size="small" class="btn" type="primary" plain @click="handelDetail(scope.row)">查看</el-button>
              <el-button size="small" class="btn" type="primary" plain @click="handleModify(scope.row)">预约设置</el-button>
              <!-- <el-button class="btn" type="primary" plain @click="handleOpenPicDialog(scope.row)">编辑</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

  </div>
</template>

<script>
export default {

  data() {
    return {
      loading: false,
      shelfValue: "", // 是否上架
      categoryValue: "", // 请搜索商品类目
      factoryValue: "", // 请搜索厂家
      projectName: "", // 请搜索商品名称
      supplyValue: "", // 请搜索供应商名称
      barCode: "", // 条形码
      optionArry: [],
      // 表格数据
      tableData: [],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getShopProductList()
    this.getCategoryInfoList()
  },
  methods: {
    // 查看
    handelDetail(row) {
      this.$router.push({
        path: '/project/detail/examineDetail',
        query: {
          projectId: row.projectId,
          projectType: row.projectType,
        }
      })
    },
    // 获取项目列表
    getShopProductList() {
      this.loading = true
      this.$axios.post(this.$api.selectProjectInfoList, {
        categoryIdList: this.categoryValue || [], // 请搜索分类
        projectName: this.projectName || null, // 搜索项目名称
        page: this.currentPage,
        pageSize: this.pageSize,
        projectType: 2,
        storeId: this.$store.state.userInfo.bizId,
      })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch((err) => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 分类
    getCategoryInfoList() {
      this.$axios.get(this.$api.projectCategoryList, {
        params: {
          page: 1,
          pageSize: 9999,
        },
      })
        .then(res => {
          if (res.code == 100) {
            this.optionArry = res.result.list
            this.optionArry.map(item => {
              if (item.children.length == 0) {
                item.children = null
              }
            })
          }
          // this.loading = false
        })
    },
    // 删除
    handleDele(row) {
      this.$confirm("确定删除该项目？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        return this.$axios.get(this.$api.deletedProjectInfo, {
          params: {
            projectId: row.projectId
          }
        })
      }).then(res => {
        if (res.code == 100) {
          this.$message.success("删除成功")
          this.getShopProductList()
        } else {
          this.$message.error("删除失败")
        }
      }).catch(() => {
        this.$message.warning('取消删除')
      })

    },
    // 预约设置
    handleModify(row) {
      this.$router.push({
        path: "/project/detail/setupDetail",
        query: { projectId: row.projectId, projectName: row.projectName }
      })
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 下拉选择
    handleSelect(value) {
      this.clearData()
      this.shelfValue = value
      this.getShopProductList()
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.getShopProductList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData()
      this.pageSize = e
      this.getShopProductList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getShopProductList()
    },
    // 图片预览
    previewImage(url) {
      this.imgList = url
      this.showViewer = true
    },
  },
}
</script>

<style lang="scss" scoped>
.all {
  // 顶部搜索
  .search {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;

    .el-input {
      width: 250px;
      margin-left: 20px;
      margin-bottom: 20px;
    }

    .el-select,
    .el-cascader,
    .el-button {
      margin-left: 20px;
      margin-bottom: 20px;
    }

    ::v-deep .el-cascader {
      width: 250px;

      .el-input,
      .el-input__inner {
        width: 250px;
      }
    }
  }

  .show_img {
    color: #069bbc;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .busilicense {
    display: block;
    width: 80px;
    height: 58px;
    border-radius: 4px;
  }

  // 图片
  .logo_pic {
    position: relative;

    ::v-deep .el-form-item__content {
      width: 100px;
      height: 100px;
    }

    .pic-row {
      display: flex;

      .pic {
        margin-right: 15px;

        .logo_uploader {
          ::v-deep .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
          }

          ::v-deep .el-upload:hover {
            border-color: #069bbc;
          }

          .avatar-uploader-icon {
            font-size: 28px;
            color: #069bbc;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
          }

          .logoimg {
            width: 100px;
            height: 100px;
            display: block;
            object-fit: cover;
          }
        }
      }
    }

    .delpic {
      position: absolute;
      top: -12px;
      color: red;
      font-size: 20px;
      cursor: pointer;
    }

    .delpic1 {
      right: -15px;
    }

    .delpic2 {
      right: -134px;
    }

    .delpic3 {
      right: -250px;
    }
  }
}
</style>
